<template>
  <svg viewBox="0 0 2610 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M923 1233v227l-112 100-112-100v-227c37 7 74 11 112 11s76-4 112-11zm-281-14v189l-93-83v-79c-233-102-397-334-397-605 0-5 0-10 1-15L0 516V318l181 130v1l49 35-1 1c-6 24-11 48-14 73-1 2-1 5-1 8-2 9-3 19-3 29-1 3-1 6-1 9-1 13-1 25-1 37 0 274 183 505 433 578zm980-901v198l-152 110v15c0 271-163 503-397 605v79l-92 83v-189c250-73 433-304 433-578 0-12-1-24-2-37v-9c-1-10-2-20-3-29-1-3-1-6-1-8-4-25-9-49-15-73v-1l48-35v-1z" />
  </svg>
</template>
